import React from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { auth } from '../../api/firebase.js';
import { setRegisterStatus } from '../../api/errorHandler';
import { conditionalAuthListener, getDefaultProfilePictureURL } from '../../api/userManagement';

class RegisterForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            login: '',
            password: '',
            rpassword: '',
            username: '',
            RegisterStatusText: '',
            defaultProfilePictureURL: getDefaultProfilePictureURL(this)
        };
        this.fileInput = React.createRef();
    }

    componentDidMount() {
        conditionalAuthListener(this);
    }

    handleChange = (event) => {
        const name = event.target.name;
        this.setState({ [name]: event.target.value });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        if (this.state.password === this.state.rpassword && this.state.username.length > 0) {
            auth.createUserWithEmailAndPassword(this.state.login, this.state.password).then(() => {
                auth.currentUser.updateProfile({
                    displayName: this.state.username,
                    photoURL: this.state.defaultProfilePictureURL
                }).then(() => {
                    this.props.handleClose();
                    setRegisterStatus("other/success");
                });
            }).catch((error) => {
                this.setState({ registerStatusText: setRegisterStatus(error.code) });
            });
        } else if (this.state.username.length <= 0) {
            this.setState({ registerStatusText: setRegisterStatus("other/too-short-username") });
        } else {
            this.setState({ registerStatusText: setRegisterStatus("other/different-passwords") });
        }
    }
    render() {
        return (
            <div>
                <form onSubmit={this.handleSubmit}>
                    <TextField
                        autoFocus
                        fullWidth
                        label="Username"
                        name="username"
                        type="login"
                        value={this.state.username}
                        marign="dense"
                        onChange={this.handleChange}
                    />

                    <TextField
                        autoFocus
                        fullWidth
                        label="Email"
                        name="login"
                        type="login"
                        value={this.state.login}
                        marign="dense"
                        onChange={this.handleChange}
                    />

                    <TextField
                        autoFocus
                        fullWidth
                        label="Password"
                        name="password"
                        type="password"
                        value={this.state.password}
                        marign="dense"
                        onChange={this.handleChange}
                    />

                    <TextField
                        autoFocus
                        fullWidth
                        label="Repeat password"
                        name="rpassword"
                        type="password"
                        value={this.state.rpassword}
                        marign="dense"
                        onChange={this.handleChange}
                    />
                    <p id="RegisterStatusText">{this.state.registerStatusText}</p>
                    <Button onClick={this.handleSubmit} color="primary">Sign Up</Button>
                </form>
            </div>
        )
    }
}

export default RegisterForm;
